import { render, staticRenderFns } from "./ShopProductBrandRelationList.vue?vue&type=template&id=3e5c249e&scoped=true"
import script from "./ShopProductBrandRelationList.vue?vue&type=script&lang=js"
export * from "./ShopProductBrandRelationList.vue?vue&type=script&lang=js"
import style0 from "./ShopProductBrandRelationList.vue?vue&type=style&index=0&id=3e5c249e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5c249e",
  null
  
)

export default component.exports